import React from 'react';
import { TableWrapper } from '../StaticTable/StaticTable.style';
import { MICRO_MACRO_TABLE_STYLES } from 'SpendController/utils';
import StaticTable from '../StaticTable/StaticTable';

function ProgramSavings(props) {
	const { programSavingsMicroMacroData, programSavingsDashboard } = props;
	return (
		<>
			<TableWrapper style={MICRO_MACRO_TABLE_STYLES}>
				<StaticTable
					data={programSavingsMicroMacroData}
					width={'200px'}
					height={200}
				/>
			</TableWrapper>
			<TableWrapper style={{ flex: 0.7 }}>
				<StaticTable
					data={programSavingsDashboard}
					width={'700px'}
					height={350}
				/>
			</TableWrapper>
		</>
	);
}

export default ProgramSavings;
